import { render, staticRenderFns } from "./ModalGestionBarquettes.vue?vue&type=template&id=8b78ba5c&"
import script from "./ModalGestionBarquettes.vue?vue&type=script&lang=js&"
export * from "./ModalGestionBarquettes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8b78ba5c')) {
      api.createRecord('8b78ba5c', component.options)
    } else {
      api.reload('8b78ba5c', component.options)
    }
    module.hot.accept("./ModalGestionBarquettes.vue?vue&type=template&id=8b78ba5c&", function () {
      api.rerender('8b78ba5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Divers/ModalGestionBarquettes.vue"
export default component.exports